<!-- Selector de estanque con flechas para ir al anterior / siguiente -->
<div class="pond-select">
  <button
    type="button"
    class="pond-select-nav"
    *ngIf="hasPrev"
    [attr.aria-label]="'filter.pond-prev' | translate"
    [ngbTooltip]="'filter.pond-prev' | translate"
    container="body"
    (click)="navigate('prev')"
  >
    <em class="fa fa-chevron-left"></em>
  </button>

  <app-search-select
    class="pond-select-input"
    [items]="items"
    [displayKey]="displayKey"
    [valueKey]="valueKey"
    [label]="label"
    [placeholder]="placeholder"
    [formControl]="control"
    (itemSelected)="onInnerSelected($event)"
  >
  </app-search-select>

  <button
    type="button"
    class="pond-select-nav"
    *ngIf="hasNext"
    [attr.aria-label]="'filter.pond-next' | translate"
    [ngbTooltip]="'filter.pond-next' | translate"
    container="body"
    (click)="navigate('next')"
  >
    <em class="fa fa-chevron-right"></em>
  </button>
</div>
